export const HOURS: string[] = Array.from({ length: 24 }, (_, i) =>
	i.toString().padStart(2, '0'),
);

export const buildMinutes = (step: number): string[] => {
	const out: string[] = [];
	for (let m = 0; m < 60; m += step) out.push(m.toString().padStart(2, '0'));
	return out;
};

export const DEFAULT_MINUTE_STEP = 5;
